import {
    CreateSymptomRequestDto,
    DeleteSymptomFromPeriodDto,
    SymptomResponseDto,
    UpdateSymptomDto,
} from '../interfaces/symptom';
import { request } from './Request';

/**
 * Servicio para manejar operaciones CRUD de flujos menstruales
 * Utiliza la clase Request para comunicarse con la API
 */
class SymptomService {
    private readonly baseEndpoint = '/sintomas';

    /**
     * Obtiene todos los síntomas de un usuario específico
     * @param payload - Datos del usuario para filtrar síntomas
     * @returns Lista de síntomas del usuario
     */
    async getSymptomsByUser(id_usuario: number): Promise<SymptomResponseDto> {
        try {
            const response = await request.get<SymptomResponseDto>(
                `${this.baseEndpoint}/all/${id_usuario}`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener flujos del usuario:', error);
            throw new Error('No se pudieron obtener los flujos del usuario');
        }
    }

    /**
     * Obtiene un síntoma específico por su ID de periodo
     * @param payload - Datos con el ID del periodo a obtener
     * @returns Datos del síntoma
     */
    async getSymptomsByIdPeriodo(id_periodo: number): Promise<SymptomResponseDto> {
        try {
            const response = await request.get<SymptomResponseDto>(
                `${this.baseEndpoint}/${id_periodo}`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener el periodo:', error);
            throw new Error('No se pudo obtener el periodo');
        }
    }

    /**
     * Crea un nuevo síntoma de un periodo menstrual
     * @param payload - Datos del nuevo síntoma
     * @returns Síntoma creado
     */
    async createSymptom(payload: CreateSymptomRequestDto[]): Promise<SymptomResponseDto> {
        try {
            const response = await request.post<SymptomResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al crear el periodo:', error);
            throw new Error('No se pudo crear el periodo');
        }
    }

    /**
     * Actualiza parcialmente un síntoma de un periodo existente
     * @param payload - Datos parciales para actualizar el síntoma
     * @returns Síntoma actualizado
     */
    async updateSymptom(payload: UpdateSymptomDto[]): Promise<SymptomResponseDto> {
        try {
            const response = await request.patch<SymptomResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al actualizar parcialmente el periodo:', error);
            throw new Error('No se pudo actualizar el periodo');
        }
    }

    /**
     * Elimina un síntoma por su ID de periodo, fecha y id_sintoma
     * @param payload - Datos con el ID de periodo, ID de síntoma y fecha del síntoma a eliminar
     * @returns Confirmación de eliminación
     */
    async deleteSymptom(payload: DeleteSymptomFromPeriodDto[]): Promise<SymptomResponseDto> {
        try {
            const response = await request.delete<SymptomResponseDto>(
                `${this.baseEndpoint}`,
                payload
            );

            return response.data;
        } catch (error) {
            console.error('Error al eliminar el síntoma:', error);
            throw new Error('No se pudo eliminar el síntoma');
        }
    }


    //**  CATALOGO DE SINTOMAS */
    async getSymptoms(): Promise<SymptomResponseDto> {
        try {
            const response = await request.get<SymptomResponseDto>(
                `catalogos/sintoma/all`
            );
            return response.data;
        } catch (error) {
            console.error('Error al obtener el periodo:', error);
            throw new Error('No se pudo obtener el periodo');
        }
    }
}

// Exportar instancia singleton
export const symptomService = new SymptomService();

// Exportar la clase para crear instancias personalizadas si es necesario
export default SymptomService;